import { useEffect, useState } from 'react';
import useDeviceRegistration from './hooks/useDeviceRegistration';
import { useParams } from 'react-router-dom';
import DeviceRegistrationForm from './DeviceRegistrationForm';
import { Heading } from '@/src/tailwindui/heading';
import { Card, CardContent } from '@/src/shadComponents/ui/card';

export default function DeviceRegistration() {
    const { registerDevice } = useDeviceRegistration();
    const { code } = useParams();
    const [deviceCode, setDeviceCode] = useState(code || '');

    const [isRegistering, setIsRegistering] = useState(false);
    const [isRegistered, setIsRegistered] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleRegisterDevice = async () => {
        setIsRegistering(true);
        const response = await registerDevice(deviceCode);

        if (response) {
            setIsRegistered(true);
        } else {
            setHasError(true);
        }

        setIsRegistering(false);
    };

    const registerDeviceWithCode = async (code: string) => {
        setIsRegistering(true);
        const response = await registerDevice(code);

        if (response) {
            setIsRegistered(true);
        } else {
            setHasError(true);
        }

        setIsRegistering(false);
    };

    useEffect(() => {
        if (code) {
            setDeviceCode(code);
            handleRegisterDevice();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    return (
        <div className="mx-auto max-w-2xl text-black dark:text-white">
            <div className="flex items-end justify-between gap-4">
                <Heading className="text-2xl">Device Registration</Heading>
            </div>
            <div className="mt-4">
                <p className=" lato-regular">
                    To register a device, launch the app on the device. You can
                    either scan the QR on the screen or enter the device code
                    below.
                </p>
                <br />
                <p className=" lato-regular">
                    If you scanned the QR code from a mobile device, the code
                    should automatically register.
                </p>
            </div>
            <br />
            <br />
            <Card>
                <CardContent className="p-6">
                    <DeviceRegistrationForm
                        code={deviceCode}
                        isRegistering={isRegistering}
                        isRegistered={isRegistered}
                        hasError={hasError}
                        setHasError={setHasError}
                        registerDeviceWithCode={registerDeviceWithCode}
                    />
                </CardContent>
            </Card>
        </div>
    );
}
